import GetStarted from "./GetStarted/GetStarted";
import Banner from "./Banner/Banner";
import './index.css';
import Communication from "./Communication/Communication";
import Connections from "./Connections/Connections";

const Home = () => {
  return (
    <>
      <Banner />
      <GetStarted />
      <Communication />
      <Connections />
    </>
  );
};

export default Home;
